import VueEditor from "../../../../plugins/VueEditor/VueEditor";
import draggable from "vuedraggable";
import algoliasearch from "algoliasearch/lite";
import AssignVariantImageModal from "./assignVariantImageModal/assignVariantImageModal.vue";
import VideoUploader from "@/views/dashboard/products/createEditProduct/VideoUploader";
import omit from "lodash/omit";

import BrandApi from "../../../../services/api/brandApi.js";
import ProductApi from "../../../../services/api/productApi.js";
import VideoApi from "@/services/api/videoApi";
import { mapGetters } from "vuex";
import * as UpChunk from "@mux/upchunk";
import utils from "@/services/utils";
import { productHelper } from "@/components/mixin/product/createEditProduct";
import ProductImages from "./productImages/ProductImages.vue";
import { DEFAULT_ERROR_MESSAGES } from "../../../../components/shared/input/formFieldHelper";

const ProductApiService = new ProductApi(),
  BrandApiService = new BrandApi(),
  VideoApiService = new VideoApi();

export default {
  mixins: [productHelper],
  provide() {
    return { parentValidator: this.$validator };
  },
  components: {
    VueEditor,
    draggable,
    AssignVariantImageModal,
    VideoUploader,
    ProductImages,
  },

  data() {
    return {
      loaded: false,
      saveDisabled: false,
      changeOccured: false,
      isAssignImageModalVisible: false,
      selectedVariant: null,
      algoliaClient: algoliasearch(this.$env.algolia().appId, this.$env.algolia().token, {
        timeouts: {
          connect: this.$utils.constants.ALGOLIA_CONNECT_TIMEOUT,
          read: this.$utils.constants.ALGOLIA_READ_TIMEOUT,
        },
      }),

      brandIndexConfig: {
        attributesToRetrieve: ["id", "brand_name", "lead_time_from", "lead_time_to"],
        facetFilters: [["status:APPROVED", "status:REGISTERED"]],
      },
      searchIndexCategories: null,
      searchIndexTag: this.$env.getOrigin() + "_tags",
      searchIndexCollection: this.$env.getOrigin() + "_collections",

      customToolbar: [
        ["bold", "italic", "underline"],
        [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
        [{ list: "ordered" }, { list: "bullet" }],
        ["clean"],
      ],
      product: {
        track_inventory: null,
        is_test_product: false,
        visible: true,
        name: "",
        description: "",
        active: true,
        images: [],
        customAssortmentImages: [],
        collections: [],
        categories: [],
        pos_price: "",
        wholesale_price: "",
        wholesale_increment: "",
        wholesale_minimum: "",
        commission_split: "",
        compare_at_price: "",
        sku: "",
        lead_time_from: "",
        lead_time_to: "",
        variants: [],
        tags: [],
        characteristics: [],
        brand_id: null,
      },
      brand_obj: null,
      tag: "",
      productImageSizeLimit: 10000000,
      variantLimit: 100,

      productTypes: [],
      colors: [],
      sizes: [],
      phrases: [],
      materials: [],
      titles: [],
      styles: [],
      error: "",

      style: "",
      title: "",
      phrase: "",
      color: "",
      size: "",
      material: "",

      availableOptions: [
        {
          name: "Size",
          isUsed: false,
        },
        {
          name: "Material",
          isUsed: false,
        },
        {
          name: "Color",
          isUsed: false,
        },
        {
          name: "Phrase",
          isUsed: false,
        },
        {
          name: "Style",
          isUsed: false,
        },
        {
          name: "Title",
          isUsed: false,
        },
      ],
      optionLimitReached: false,
      usedOptions: 0,
      combinations: [],
      createdProductId: null,
      isLoading: false,
      imageIdsForDelete: [],
      selectedBrand: null,
      imagesToUpload: [],
      uploadedImageIndexes: [],
      productDataLoaded: false,
      testerProducts: [],
      videoFile: null,
      showNonUniqueOptionErrorsOn: [],
    };
  },

  beforeMount() {
    this.$loader.$emit("trigger", true);
    this.searchIndexCategories = this.algoliaClient.initIndex(this.$env.getOrigin() + "_categories");
    this.searchIndexTesterProducts = this.algoliaClient.initIndex(this.$env.getOrigin() + "_products");

    this.initLoad();
  },

  beforeRouteLeave(from, to, next) {
    const _self = this;

    if (_self.changeOccured) {
      _self
        .$swal({
          title: "Are you sure?",
          text: "Your changes wont be saved",
          showCancelButton: true,
          cancelButtonText: "Cancel",
          confirmButtonText: "Confirm",
        })
        .then(function (confirm) {
          if (confirm.value) {
            next();
          } else {
          }
        });
    } else {
      next();
    }
  },

  watch: {
    "product.pos_price": function (oldVal, newVal) {
      if (this.product.variants.length) {
        this.assignPrices(oldVal, newVal, "pos_price");
      }
    },

    "product.wholesale_price": function (oldVal, newVal) {
      if (this.product.variants.length) {
        this.assignPrices(oldVal, newVal, "wholesale_price");
      }
    },

    // 'product.compare_at_price': function(oldVal, newVal) {
    //     if(this.product.variants.length) {
    //         this.assignPrices(oldVal, newVal, 'compare_at_price');
    //     }
    // },

    "product.sku": function (oldVal, newVal) {
      if (this.product.variants.length) {
        this.assignPrices(oldVal, newVal, "sku");
      }
    },
    "product.track_inventory": function (oldVal) {
      // if (oldVal) {
      //   this.product.variants.forEach(function (variant) {
      //     variant.inventory_quantity = null;
      //   });
      // }
    },

    product: {
      handler() {
        if (this.loaded) {
          this.changeOccured = true;
        }
      },
      deep: true,
    },
  },

  methods: {
    addTester,
    removeTester,
    testVariantDropdownCallback,
    back,
    getProduct,
    getCollectionsByIds,
    getProductCategories,
    selectProductType,
    selectBrand,
    triggerImageUpload,
    onProductImageInputChange,
    generateImage,
    pickOptionValue,
    calculateVariantArray,
    calculatePermutations,
    removeVariant,
    removeVariantFromList,
    assignPrices,
    updateVariantValue,
    insertItemIntoArray,
    removeItemFromArray,
    checkProduct,
    save,
    deleteImageRequest,
    variantImageChanged,
    toggleAssignVariantImageModal,
    onSaveDone,
    activateWatcher,
    getTesterProducts,
    resetVariantTesters,
    initLoad,
    getBrandMe,
    uploadChanged,
    removeVideo,
    handleNewVideoChange,
    uploadVideo,
    unselectCategory,
    urlFormatter: utils.urlSafeString,
    onProductOptionDropped,
    onOptionChange,
    isOptionUnique,
    showNoneUniqueOptionError,
  },

  computed: {
    ...mapGetters({
      user: "userState",
    }),
    isShopifyUser() {
      return this.user?.role === "BRAND" && this.brand_obj?.shopify !== null;
    },
    shopifyProductNotActive() {
      return (
        this.product.shopify &&
        (this.product.shopify.status === "archived" ||
          this.product.shopify.status === "deleted" ||
          this.product.shopify.status === "draft")
      );
    },
  },
};

function uploadChanged(data) {
  this.saveDisabled = !this.saveDisabled;
  if (data) {
    this.product.video = data;
  }
}

function handleNewVideoChange(file) {
  this.videoFile = file;
}

function removeVideo() {
  if (this.product.video) {
    this.product.video = null;
  }
}

function addTester(variantIndex) {
  this.product.variants[variantIndex].has_tester = true;
  this.$forceUpdate();
}

function removeTester(variantIndex) {
  this.product.variants[variantIndex].has_tester = false;
  this.product.variants[variantIndex].tester_minimum_quantity = null;
  this.product.variants[variantIndex].tester_product_id = null;
  this.product.variants[variantIndex].tester_variant_id = null;
  this.$forceUpdate();
}

async function initLoad() {
  if (this.user.role === "BRAND") {
    await this.getBrandMe();
    this.product.brand_id = this.user.brand_id;
    this.getTesterProducts();
  }

  this.getProductCategories();
}

function getBrandMe() {
  BrandApiService.getBrandMe().then(({ data }) => {
    this.brand_obj = data;
    const isShopifySync = this.brand_obj.shopify !== null,
      isCreateNewRoute = this.$route.name === "createProduct";
    if (isShopifySync && isCreateNewRoute) {
      this.$router.push("/unavailable");
    }
  });
}

function resetVariantTesters(e) {
  if (this.$route.name === "editProduct") {
    e.preventDefault();

    if (this.product.is_test_product && (this.product.pos_price <= 0 || this.product.wholesale_price <= 0)) {
      this.$swal("Attention", "Product retail and wholesale price must be greater than $0.00");

      return;
    }

    if (this.product.is_test_product) {
      for (let variant of this.product.variants) {
        if (variant.pos_price <= 0 || variant.wholesale_price <= 0) {
          this.$swal("Attention", "Variant retail and wholesale price must be greater than $0.00");

          return false;
        }
      }
    }

    this.$swal({
      title: "Are you sure?",
      text: "This action requires product saving, do you want to continue?",
      showCancelButton: true,
      cancelButtonText: "Cancel",
      confirmButtonText: "Yes",
    }).then((confirm) => {
      if (confirm.value) {
        this.product.is_test_product = !this.product.is_test_product;
        this.save(true);
      } else {
      }
    });
  } else {
    this.product.is_test_product = !this.product.is_test_product;

    if (this.product.is_test_product) {
      this.product.variants.forEach((variant) => {
        variant.has_tester = false;
        variant.tester_minimum_quantity = null;
        variant.tester_product_id = null;
        variant.tester_varriant_id = null;
      });
    }
  }
}

function testVariantDropdownCallback(variant, variantIndex) {
  this.product.variants[variantIndex].tester_variant_id = variant.id;
  this.product.variants[variantIndex].tester_variant_name = variant.name;
}

function getTesterProducts(brandChanged) {
  this.searchIndexTesterProducts.clearCache();
  return this.searchIndexTesterProducts
    .search({
      query: "",
      hitsPerPage: this.$utils.constants.GET_TESTER_PRODUCTS_LIMIT,
      facets: "*,brand.id,is_test_product",
      distinct: false,
      facetFilters: [["is_test_product: true"], [`brand.id:${this.product.brand_id}`]],
    })
    .then((response, err) => {
      if (err) {
        this.$logger.notify(new Error(err));

        return;
      }

      if (brandChanged) {
        this.product.variants.forEach((variant) => {
          variant.tester_minimum_quantity = null;
          variant.tester_product_id = null;
          variant.tester_variant_id = null;
          variant.testerVariants = [];
        });
      }
      return (this.testerProducts = response.hits);
    });
}

function back(productId) {
  let routeQuery = {
    page: this.$route.query.page,
  };

  if (this.$route.query.product_search_keyword)
    routeQuery.product_search_keyword = this.$route.query.product_search_keyword;
  if (this.$route.query.brand) routeQuery.brand = this.$route.query.brand;
  if (this.$route.query.category) routeQuery.category = this.$route.query.category;
  if (this.$route.query.active) routeQuery.active = this.$route.query.active;
  if (productId) routeQuery.productBeingSaved = productId;

  this.$router.push({
    name: "dashboardProducts",
    query: routeQuery,
  });
}

function variantImageChanged(variant, imageIndex, action) {
  let _self = this;

  if (!variant.id) {
    _self.$swal("Attention", "Cannot upload image to unsaved variant. Make sure to save product first.");
    return;
  }

  _self.$loader.$emit("trigger", true);

  if (action === "ADD") {
    ProductApiService.assignImageToVariant({ variantId: variant.id, imageId: _self.product.images[imageIndex].id })
      .then((response) => {
        _self.product.variants[variant.index].image_url = _self.product.images[imageIndex].src;
        _self.$loader.$emit("trigger", false);
      })
      .catch((error) => {
        _self.$loader.$emit("trigger", false);
        if (error.response) {
          _self.$swal("Attention", error.response.data.error_message);
        } else {
          _self.$logger.notify(new Error(error));
        }
      });
  } else {
    ProductApiService.removeVariantImage({ variantId: variant.id })
      .then((response) => {
        _self.product.variants[variant.index].image_url = null;
        _self.$loader.$emit("trigger", false);
      })
      .catch((error) => {
        _self.$loader.$emit("trigger", false);
        if (error.response) {
          _self.$swal("Attention", error.response.data.error_message);
        } else {
          _self.$logger.notify(new Error(error));
        }
      });
  }
}

function toggleAssignVariantImageModal(variant, index) {
  this.selectedVariant = variant;
  this.selectedVariant.index = index;
  this.isAssignImageModalVisible = true;
}

function selectProductType(categoryItem) {
  const categoryIds = this.product.categories,
    productAlreadyHasThisCategory = categoryIds.map((cat) => cat.entity_id).includes(categoryItem.entity_id);
  if (productAlreadyHasThisCategory) {
    this.product.categories = categoryIds.filter((categoryData) => categoryData !== categoryItem);
  } else {
    this.product.categories.push(categoryItem);
  }

  if (this.product.categories?.length) {
    this.$validator.errors.remove("product category");
  }
}

function unselectCategory(id) {
  this.product.categories = this.product.categories.filter((catId) => catId.entity_id !== id);
}

function selectBrand(entity) {
  this.product.brand_id = entity.id;
  this.selectedBrand = entity;

  this.product.lead_time_from = entity.lead_time_from;
  this.product.lead_time_to = entity.lead_time_to;

  // pull tester product for given brand if product isn't marked as tester
  if (!this.product.is_test_product) {
    this.getTesterProducts(true);
  }
}

// used for product.collections & product.tags arrays
function insertItemIntoArray(entity, array, refine) {
  let _self = this;

  if (array === "collections") {
    // TODO: use ! instead return false on true;
    if (_self.product.collections.filter((collection) => entity.id === collection.id).length > 0) {
      return false;
    } else {
      _self.product[array].push(entity);
      refine("");
    }
  } else {
    if (this.product[array].includes(entity) || !entity.replace(/ /g, "").length) {
      return false;
    } else {
      this.product[array].push(entity);
      refine("");
    }
  }
}

// used for product.collections & product.tags arrays
function removeItemFromArray(array, index) {
  this.product[array].splice(index, 1);
}

function pickOptionValue(type, val) {
  if (this.isOptionUnique(type, val)) {
    this.showNonUniqueOptionErrorsOn.push(type);
    return;
  }
  this.showNonUniqueOptionErrorsOn = this.showNonUniqueOptionErrorsOn.filter((item) => item !== type);
  this.calculateVariantArray(this[type + "s"], val, type);
}

function onOptionChange(type, event) {
  const value = event.target.value;
  if (this.isOptionUnique(type, value)) {
    this.showNonUniqueOptionErrorsOn.push(type);
  } else {
    this.showNonUniqueOptionErrorsOn = this.showNonUniqueOptionErrorsOn.filter((item) => item !== type);
  }
}

function isOptionUnique(groupKey, value) {
  return this._data[`${groupKey}s`].find((item) => item.option.toLowerCase() === value.toLowerCase());
}

function showNoneUniqueOptionError(option) {
  return this.showNonUniqueOptionErrorsOn.find(
    (item) => item === option.name.toLowerCase() && this._data[option.name.toLowerCase()]
  );
}

function calculateVariantArray(array, variant, type) {
  if (!variant.replace(/ /g, "").length) {
    return;
  }

  for (var i = 0; i < array.length; i++) {
    if (array[i].option === variant.replace(/ /g, "").toLowerCase()) {
      return;
    }
  }

  // check how many options are used
  if (this.usedOptions <= 3) {
    // set option used flag to true;
    for (var j = 0; j < this.availableOptions.length; j++) {
      if (!this.availableOptions[j].isUsed && type === this.availableOptions[j].name.toLowerCase()) {
        this.availableOptions[j].isUsed = true;
        this.usedOptions += 1;

        if (this.usedOptions === 3) {
          this.optionLimitReached = true;
        }
      }
    }
  } else {
    return;
  }

  array.push({ option: variant, type: type });
  this.calculatePermutations();
  this[type] = ""; // clear input model
}

function calculatePermutations() {
  let allArrays = [];

  if (this.sizes.length > 0) {
    allArrays.push(this.sizes);
  }

  if (this.materials.length > 0) {
    allArrays.push(this.materials);
  }

  if (this.colors.length > 0) {
    allArrays.push(this.colors);
  }

  if (this.phrases.length > 0) {
    allArrays.push(this.phrases);
  }

  if (this.styles.length > 0) {
    allArrays.push(this.styles);
  }

  if (this.titles.length > 0) {
    allArrays.push(this.titles);
  }

  if (
    !this.phrases.length &&
    !this.sizes.length &&
    !this.colors.length &&
    !this.materials.length &&
    !this.styles.length &&
    !this.titles.length
  ) {
    this.combinations = [];
    this.product.variants = [];

    return;
  }

  // stack functions for calculating permutations

  let divisors = [];

  for (let i = allArrays.length - 1; i >= 0; i--) {
    divisors[i] = divisors[i + 1] ? divisors[i + 1] * allArrays[i + 1].length : 1;
  }

  function getPermutation(n, allArrays) {
    let result = [],
      curArray;

    for (let i = 0; i < allArrays.length; i++) {
      curArray = allArrays[i];
      result.push(curArray[Math.floor(n / divisors[i]) % curArray.length]);
    }

    return result;
  }

  let numPerms = allArrays[0].length;

  for (let i = 1; i < allArrays.length; i++) {
    numPerms *= allArrays[i].length;
  }

  let combinations = [];

  for (let i = 0; i < numPerms; i++) {
    combinations.push(getPermutation(i, allArrays));
  }

  // end result

  this.combinations = combinations;

  let posPrices = [],
    // compareAtPrices = [],
    wholesalePrices = [],
    skus = [],
    inStockList = [],
    ids = [],
    images = [],
    testerMinimumQuantities = [],
    testerProductIds = [],
    testerVariantIds = [],
    testerProductNames = [],
    testerVariantNames = [],
    hasTester = [];

  // extract current prices
  for (var y = 0; y < this.product.variants.length; y++) {
    ids.push(this.product.variants[y].id);
    posPrices.push(this.product.variants[y].pos_price);
    // compareAtPrices.push(this.product.variants[y].compare_at_price);
    wholesalePrices.push(this.product.variants[y].wholesale_price);
    skus.push(this.product.variants[y].skus);
    inStockList.push(this.product.variants[y].in_stock);
    images.push(this.product.variants[y].image_url);
    testerMinimumQuantities.push(this.product.variants[y].tester_minimum_quantity);
    hasTester.push(this.product.variants[y].has_tester);
    testerProductIds.push(this.product.variants[y].tester_product_id);
    testerVariantIds.push(this.product.variants[y].tester_variant_id);
    testerProductNames.push(this.product.variants[y].tester_product_name);
    testerVariantNames.push(this.product.variants[y].tester_variant_name);
  }

  this.product.variants = [];

  // assign data to final product
  for (let x = 0; x < this.combinations.length; x++) {
    let variant = {};

    for (let j = 0; j < this.combinations[x].length; j++) {
      variant["option" + (j + 1)] = this.combinations[x][j];
    }

    this.product.variants.push(variant);
  }

  for (var a = 0; a < this.product.variants.length; a++) {
    // if(compareAtPrices[a] !== undefined) {
    //     this.product.variants[a].compare_at_price = compareAtPrices[a];
    // } else {
    //     this.product.variants[a].compare_at_price = this.product.compare_at_price;
    // }

    if (images[a] !== undefined) {
      this.product.variants[a].image_url = images[a];
    } else {
      this.product.variants[a].image_url = null;
    }

    if (posPrices[a] !== undefined) {
      this.product.variants[a].pos_price = posPrices[a];
    } else {
      this.product.variants[a].pos_price = this.product.pos_price;
    }

    // if(compareAtPrices[a] !== undefined) {
    //     this.product.variants[a].compare_at_price = compareAtPrices[a];
    // } else {
    //     this.product.variants[a].compare_at_price = this.product.compare_at_price;
    // }

    if (wholesalePrices[a] !== undefined) {
      this.product.variants[a].wholesale_price = wholesalePrices[a];
    } else {
      this.product.variants[a].wholesale_price = this.product.wholesale_price;
    }

    if (skus[a] !== undefined) {
      this.product.variants[a].sku = skus[a];
    } else {
      this.product.variants[a].sku = this.product.sku;
    }

    if (inStockList[a] !== undefined) {
      this.product.variants[a].in_stock = inStockList[a];
    } else {
      this.product.variants[a].in_stock = true;
    }

    if (testerMinimumQuantities[a] !== undefined) {
      this.product.variants[a].tester_minimum_quantity = testerMinimumQuantities[a];
    }

    if (testerProductIds[a] !== undefined) {
      this.product.variants[a].tester_product_id = testerProductIds[a];
    }

    if (testerVariantIds[a] !== undefined) {
      this.product.variants[a].tester_variant_id = testerVariantIds[a];
    }

    if (testerProductNames[a] !== undefined) {
      this.product.variants[a].tester_product_name = testerProductNames[a];
    }

    if (testerVariantNames[a] !== undefined) {
      this.product.variants[a].tester_variant_name = testerVariantNames[a];
    }

    if (hasTester[a] !== undefined) {
      this.product.variants[a].has_tester = hasTester[a];
    }

    if (ids[a] !== undefined) {
      this.product.variants[a].id = ids[a];
    }
  }
}

function removeVariant(index, array, type) {
  array.splice(index, 1);

  if (array.length === 0) {
    for (var i = 0; i < this.availableOptions.length; i++) {
      if (this.availableOptions[i].name.toLowerCase() === type) {
        this.availableOptions[i].isUsed = false;
        this[type + "Visible"] = false;
        this.usedOptions -= 1;
        this.optionLimitReached = false;
        this.$forceUpdate();
      }
    }
  }

  this.calculatePermutations();
}

function removeVariantFromList(index) {
  this.product.variants.splice(index, 1);
}

function assignPrices(oldVal, newVal, priceType) {
  for (let i = 0; i < this.product.variants.length; i++) {
    this.$validator.reset(i + " variant price");

    if (this.product.variants[i][priceType] === newVal) {
      this.product.variants[i][priceType] = this.product[priceType];
    }

    this.$forceUpdate();
  }
}

function updateVariantValue(prop, value, index) {
  if (prop === "sku" && value === "") {
    value = null;
  }

  this.product.variants[index][prop] = value;
  this.$forceUpdate();
}

function triggerImageUpload(isCustomAssortmentImage) {
  if (isCustomAssortmentImage) {
    this.$refs.productCustomImageInput.click();
  } else {
    this.$refs.productImageInput.click();
  }
}

function onProductImageInputChange(e, isCustomAssortmentImage = false) {
  var file = e.target.files[0];

  if (!file) return;

  if (file.size > this.productImageSizeLimit) {
    this.$swal("Attention", "Image size cannot be greater than 10 MB");
  } else {
    this.generateImage(file, isCustomAssortmentImage);
  }
}

function generateImage(file, isCustomAssortmentImage) {
  var reader = new FileReader(),
    image = new Image(),
    _self = this;

  reader.readAsDataURL(file);
  reader.onload = (e) => (image.src = e.target.result);
  image.onload = (e) => {
    const imageMatchesRequiredDimensions =
        image.naturalWidth === _self.$utils.imageSize("productImage")["width"] &&
        image.naturalHeight === _self.$utils.imageSize("productImage")["height"],
      customAssortmentImageMatchesRequiredDimensions =
        image.naturalWidth <= _self.$utils.imageSize("productCustomAssortmentImage")["width"] &&
        image.naturalHeight <= _self.$utils.imageSize("productCustomAssortmentImage")["height"],
      fileData = { src: e.target.src, file };
    if (isCustomAssortmentImage && customAssortmentImageMatchesRequiredDimensions) {
      _self.product.customAssortmentImages.push(fileData);
      _self.$refs.productCustomImageInput.value = "";
    } else if (imageMatchesRequiredDimensions) {
      // success
      _self.product.images.push(fileData);
      _self.$refs.productImageInput.value = "";
    } else {
      _self.$logger.notify("image dimensions error", {
        user: _self.user.email,
        product: _self.$route.params.productId ? _self.$route.params.productId : "n/a",
        image_dimensions: {
          width: image.naturalWidth,
          height: image.naturalHeight,
        },
      });

      // fail
      if (isCustomAssortmentImage) {
        _self.$swal(
          "Attention",
          `Image dimensions cannot be greater than ${
            _self.$utils.imageSize("productCustomAssortmentImage")["width"]
          }px by 
                    ${_self.$utils.imageSize("productCustomAssortmentImage")["height"]}px`
        );
      } else {
        _self.$swal(
          "Attention",
          `Image dimensions must be ${_self.$utils.imageSize("productImage")["width"]}px by 
                    ${_self.$utils.imageSize("productImage")["height"]}px`
        );
      }

      _self.$refs.productImageInput.value = "";

      if (_self.$refs.productCustomImageInput) {
        _self.$refs.productCustomImageInput.value = "";
      }
    }
  };
}

async function getProductCategories() {
  this.productTypes = (await this.$utils.getProductCategories()).map((container) => {
    return {
      ...container,
      view_components: container.children_containers.length
        ? container.children_containers.flatMap((_container) => _container.view_components)
        : container.view_components,
    };
  });

  if (this.$route.params.productId) {
    this.getProduct();
  } else {
    if (this.brand_obj) {
      this.product.lead_time_from = this.brand_obj.lead_time_from;
      this.product.lead_time_to = this.brand_obj.lead_time_to;
    }

    this.activateWatcher();
    this.$loader.$emit("trigger", false);
  }
}

function getProduct() {
  let _self = this;

  ProductApiService.getProduct(_self.$route.params.productId, true)
    .then(async (response) => {
      response.data.categories = this.$utils.mapCategoriesToProductTypeList(
        response.data.categories,
        this.productTypes
      );

      var product = {
        track_inventory: response.data.track_inventory,
        is_test_product: response.data.is_test_product,
        visible: response.data.visible,
        name: response.data.name,
        description: response.data.description,
        active: response.data.active,
        images: [],
        customAssortmentImages: [],
        collections: [],
        characteristics: [],
        pos_price: response.data.pos_price,
        wholesale_price: response.data.wholesale_price,
        sku: response.data.sku,
        commission_split: response.data.commission_split,
        compare_at_price: response.data.compare_at_price,
        lead_time_from: response.data.lead_time_from,
        lead_time_to: response.data.lead_time_to,
        variants: [],
        tags: response.data.tags,
        brand_id: response.data.brand_id,
        categories: response.data.categories,
        wholesale_minimum: response.data.wholesale_minimum,
        wholesale_increment: response.data.wholesale_increment,
        prioritized: response.data.prioritized,
        video: response.data.video,
        shopify: response.data.shopify,
      };

      // set product images array
      response.data.images.forEach(function (image) {
        product.images.push({
          id: image.id,
          src: image.url,
          originalSrc: image.original_url,
          cropParams: image.crop_params || {},
          file: null,
          ordinal: image.ordinal,
        });
      });

      product.categories.forEach((catObject) => {
        this.productTypes = this.productTypes.map((parent) => {
          parent.view_components.map((child) => ({
            ...child,
            ...(child.entity_id === catObject.entity_id && (child.selected = true)),
          }));
          return parent;
        });
      });
      // set custom assortment images array
      response.data.custom_assortment_images.forEach((image) => {
        product.customAssortmentImages.push({ id: image.id, src: image.url, file: null, ordinal: image.ordinal });
      });

      // set product brand
      _self.selectedBrand = {
        id: response.data.brand_id,
        name: response.data.brand_name,
        lead_time_from: response.data.brand_lead_time_from,
        lead_time_to: response.data.brand_lead_time_to,
      };

      // set variant options options
      if (response.data.characteristic_options) {
        for (let property in response.data.characteristic_options) {
          for (let j = 0; j < _self.availableOptions.length; j++) {
            if (property.toLowerCase() === _self.availableOptions[j].name.toLowerCase()) {
              _self.availableOptions[j].isUsed = true;
              _self.usedOptions += 1;
            }
          }
        }
      }

      // parse variants
      var variants = [];

      for (var i = 0; i < response.data.variants.length; i++) {
        var variant = {},
          objKeys = Object.keys(response.data.variants[i].characteristic_option),
          values = Object.values(response.data.variants[i].characteristic_option);

        var keys = [];

        objKeys.forEach(function (key) {
          keys.push(key.toLowerCase());
        });

        for (var j = 0; j < keys.length; j++) {
          var duplicateIndex = null;

          variant["option" + Number(j + 1)] = {
            type: keys[j],
            option: values[j],
          };

          _self[keys[j] + "s"].forEach(function (element, index) {
            if (element.option === values[j]) {
              duplicateIndex = index;
            }
          });

          if (duplicateIndex === null) {
            _self[keys[j] + "s"].push({ type: keys[j], option: values[j] });
          }
        }

        variant.id = response.data.variants[i].id;
        variant.compare_at_price = response.data.variants[i].compare_at_price;
        variant.wholesale_price = response.data.variants[i].wholesale_price;
        variant.sku = response.data.variants[i].sku;
        variant.in_stock = response.data.variants[i].in_stock;
        variant.pos_price = response.data.variants[i].pos_price;
        variant.image_url = response.data.variants[i].image_url;
        variant.out_of_stock = response.data.variants[i].out_of_stock;
        variant.inventory_quantity = response.data.variants[i].inventory_quantity
          ? response.data.variants[i].inventory_quantity
          : 0;

        if (response.data.variants[i].tester_product_id) {
          variant.has_tester = true;
          variant.tester_minimum_quantity = response.data.variants[i].tester_minimum_quantity;
          variant.tester_product_name = response.data.variants[i].tester_product_name;
          variant.tester_product_id = response.data.variants[i].tester_product_id;
          variant.tester_variant_id = response.data.variants[i].tester_variant_id;
          variant.tester_variant_name = await selectTesterVariant(variant.tester_product_id, variant.tester_variant_id);
        }

        variants.push(variant);
      }
      product.variants = variants;

      _self.product = product;
      if (!product.is_test_product && product.brand_id) {
        await _self.getTesterProducts();
      }

      if (_self.usedOptions >= 3) {
        _self.optionLimitReached = true;
      }

      _self.productDataLoaded = true;
      _self.$forceUpdate();
      _self.getCollectionsByIds(response.data.collections);
    })
    .catch((error) => {
      if (error.response) {
        _self.$swal("Attention", error.response.data.error_message);
      } else {
        _self.$logger.notify(new Error(error));
      }
    });
}

function getCollectionsByIds(array) {
  let _self = this;

  var getCollectionObjectsIndex = _self.algoliaClient.initIndex(_self.$env.getOrigin() + "_collections");

  getCollectionObjectsIndex.getObjects(array).then((response, err) => {
    if (err) {
      _self.$swal("Attention", err);

      return;
    }

    _self.product.collections = response.results;
    _self.$forceUpdate();
    _self.$loader.$emit("trigger", false);
    _self.activateWatcher();
  });
}

async function checkProduct() {
  let _self = this;

  if (_self.product.description.length > 5000) {
    _self.$swal("Attention", "Product description cannot be greater than 5000 chars");

    return;
  }

  if (_self.product.variants.length > 100) {
    _self.$swal("Attention", "Variant limit exceeded. You can create up to " + _self.variantLimit + " variants.");

    return;
  }

  if (_self.product.active) {
    if (!_self.product.variants.length) {
      _self.$swal("Attention", "Please create at least one variant");

      return;
    }

    if (!_self.product.images.length) {
      _self.$swal("Attention", "Please add at least one image");

      return;
    }
  }

  if (this.saveDisabled) {
    this.$swal("Attention", "Video Upload in Progress.");

    return;
  }

  if (!this.product.categories?.length) {
    this.$validator.errors.add({
      field: "product category",
      msg: DEFAULT_ERROR_MESSAGES.required,
    });
    return;
  }

  const skuErrors = _self.$validator.errors?.items?.filter((error) => error.field?.includes("product_variant_sku"));
  if (skuErrors.length) {
    this.$swal("Attention", "Invalid sku");
    return;
  }

  const valid = await _self.$validator.validate();

  if (_self.product.active && this.user.role === "ADMIN") {
    if (!_self.product.lead_time_from || _self.product.lead_time_from === "") {
      _self.product.lead_time_from = _self.selectedBrand.lead_time_from;
    }

    if (
      (!_self.product.lead_time_to || _self.product.lead_time_to === "") &&
      Number(_self.selectedBrand.lead_time_to) >= Number(_self.product.lead_time_from)
    ) {
      _self.product.lead_time_to = _self.selectedBrand.lead_time_to;
    }
  }

  if (_self.product.lead_time_to && Number(_self.product.lead_time_from) > _self.product.lead_time_to) {
    _self.$swal("Attention", "Lead time from cannot be greater than lead time to");
    return;
  }

  if (!valid) {
    const firstErrorFieldName = this.errors.items[0].field,
      targetElement = document.querySelectorAll(`[name='${firstErrorFieldName}']`)[0].parentElement;
    _self.$utils.scrollTo(targetElement);
  } else {
    _self.save();
  }
}

async function save(skipBack) {
  const _self = this;

  let productId = null;

  if (_self.$route.params.productId) {
    productId = _self.$route.params.productId;
  }

  _self.changeOccured = false;

  if (!skipBack) {
    _self.back(productId);
  }

  _self.availableOptions.forEach(function (option) {
    if (option.isUsed) {
      _self.product.characteristics.push(option.name.toLowerCase());
    }
  });

  _self.product.variants.forEach(function (variant, index) {
    delete variant.testerVariants;
    variant.characteristic_option = {};
    variant.ordinal = index + 1;
    for (var i = 1; i <= 3; i++) {
      if (variant["option" + i] !== undefined) {
        variant.characteristic_option[variant["option" + i].type] = variant["option" + i].option;
      }
    }
  });
  _self.product.variants.forEach(function (variant, index) {
    if (!_self.product.track_inventory) {
      delete variant.inventory_quantity;
    } else {
      variant.inventory_quantity = parseInt(variant.inventory_quantity);
    }
  });

  var productCollectionsForSave = [];

  _self.product.collections.forEach(function (collection) {
    productCollectionsForSave.push(collection.id);
  });

  var productForSave = _self.$utils.deepClone(_self.product);

  productForSave.collections = productCollectionsForSave;
  productForSave.characteristic_option = this.collectCharacteristicOptionsForSavingSort();

  /*
        Check if create or edit.
        Images with ids are sent with updated ordinal numbers
    */
  if (productId) {
    productForSave.images = [];
    productForSave.custom_assortment_images = [];
    productForSave.imagesForUpload = [];
    productForSave.customAssortmentImagesForUpload = [];

    productForSave.images = _self.product.images.map((image) => {
      return image.id;
    });

    _self.product.customAssortmentImages.forEach(function (image, index) {
      if (image.ordinal !== undefined) {
        image.ordinal = index + 1;
        productForSave.custom_assortment_images.push(image);
      } else {
        if (image.file) {
          productForSave.customAssortmentImagesForUpload.push({ file: image.file, ordinal: index + 1 });
        }
      }
    });
  } else {
    productForSave.images = [];
    productForSave.images = _self.product.images.map((image) => {
      return image.id;
    });

    productForSave.custom_assortment_images = [];
    _self.product.customAssortmentImages.forEach(function (image) {
      // for some reason - deepClone of product doesn't copy file object from customAssortmentImages[]
      productForSave.custom_assortment_images.push({ file: image.file, ordinal: image.ordinal });
    });
  }

  _self.$notify.$emit("fire", {
    message: "Saving product general info..",
    data: {
      images: productId ? productForSave.imagesForUpload.length : productForSave.images.length,
    },
    type: "working",
  });

  if (productForSave.categories) {
    productForSave.category_ids = productForSave.categories.map((item) => {
      return item.entity_id;
    });
    productForSave = omit(productForSave, "categories");
  }

  if (productId) {
    const request =
      this.user.role === "PRODUCT_BUILDER"
        ? ProductApiService.updateProductAsProductBuilder
        : ProductApiService.updateProduct;
    productForSave.id = productId;

    request(productForSave)
      .then(async (response) => {
        if (_self.imageIdsForDelete.length) {
          await _self.deleteImageRequest();
        }
      })
      .catch((error) => {
        // notify that product wasn't saved
        _self.$notify.$emit("fire", {
          message: "Error saving product",
          type: "error",
          fadeTime: 5000,
        });

        if (error.response) {
          _self.$swal("Attention", error.response.data.error_message);
        } else {
          _self.$logger.notify(new Error(error));
        }
      });
  } else {
    const request =
      this.user.role === "PRODUCT_BUILDER"
        ? ProductApiService.createProductAsProductBuilder
        : ProductApiService.createProduct;

    request({
      ...productForSave,
      images: productForSave.images,
    })
      .then(async (response) => {
        this.videoFile && (await this.uploadVideo(this.videoFile, response.data.id));
      })
      .catch((error) => {
        // notify that product wasn't saved
        _self.$notify.$emit("fire", {
          message: "Error saving product",
          type: "error",
          fadeTime: 5000,
        });

        if (error.response) {
          _self.$swal("Attention", error.response.data.error_message);
        } else {
          _self.$logger.notify(new Error(error));
        }
      });
  }
}

async function deleteImageRequest() {
  let _self = this;
  let deleteImageRequests = _self.imageIdsForDelete.map((id) => ProductApiService.removeImageFromProduct(id));
  return Promise.all(deleteImageRequests).catch((error) => {
    if (error.response) {
      _self.$swal("Attention", error.response.data.error_message);
    } else {
      _self.$logger.notify(new Error(error));
    }
  });
}

function onSaveDone() {
  this.initLoad();
}

function activateWatcher() {
  const _self = this;

  _self.$nextTick(() => {
    _self.loaded = true;
  });
}

function selectTesterVariant(productId, variantId) {
  return ProductApiService.getProduct(productId).then((response) => {
    let variants = response.data.variants,
      variantName = null;

    variants.forEach((variant) => {
      if (variant.id === variantId) {
        variantName = Object.values(variant.characteristic_option).join(" ");
      }
    });

    return variantName;
  });
}

async function uploadVideo(event, productId) {
  this.$notify.$emit("fire", {
    message: "Uploading video..",
    type: "working",
    fadeTime: 500000,
  });
  return new Promise(async (resolutionFunc, rejectionFunc) => {
    const { data } = await VideoApiService.getVideoUploadUrl(productId),
      uploadId = data.upload_id,
      upload = UpChunk.createUpload({
        endpoint: data.url,
        file: event.target.files[0],
        chunkSize: 768,
      });
    upload.on("error", () => {
      this.$swal("Attention", "Something went wrong. Please Try again");
      rejectionFunc();
    });
    upload.on("success", () => {
      const api = async () => {
        const { data } = await VideoApiService.getAssetId(uploadId);
        return data.processed ? data.playback_ids : false;
      };
      this.$utils
        .poll({
          fn: api,
          validate: (asset) => Boolean(asset),
          interval: 1000,
        })
        .then(async (playback) => {
          const video = {
            entity_type: "PRODUCT",
            url: playback[0].id,
          };
          VideoApiService.setVideo(productId, video).then((response) => {
            this.$notify.$emit("close", true);
            resolutionFunc();
          });
        })
        .catch(() => {
          this.$swal("Attention", "Something went wrong. Please Try again");
          rejectionFunc();
        });
    });
  });
}

function onProductOptionDropped() {
  this.calculatePermutations();
}
